// Libraries
import React from 'react'

// Components
import {FontWeight, Heading, HeadingElement} from '@influxdata/clockface'

interface Props {
  title: string
  subtitle?: string
}

const SplashSectionHeading = ({title, subtitle}: Props): JSX.Element => {
  return (
    <>
      <Heading element={HeadingElement.H2} appearance={HeadingElement.H3}>
        {title}
      </Heading>
      {subtitle && (
        <Heading
          element={HeadingElement.H4}
          weight={FontWeight.Light}
          className="sign-up--splash-subheading"
        >
          {subtitle}
        </Heading>
      )}
    </>
  )
}

export default SplashSectionHeading
